export const selectLessonDetail = (state) => state.lessonDetail.lessonDetail;
export const selectLoading = (state) => state.lessonDetail.loading;
export const selectError = (state) => state.lessonDetail.error;
